import { icons, logos } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  background-image: url(${icons.YoloLogoWhiteIcon});
  background-repeat: no-repeat;
  background-size: cover;
  width: 160px;
  min-width: 160px;
  margin: 2px 0 0 20px;
  height: 30px;
  display: block;

  @media (max-width: 1600px) {
    width: 160px;
    min-width: 160px;
  }

  @media (max-width: 800px) {
    margin-left: 10px;
    background: url(${logos.yolorekt_moon_white}) center center / 35px auto no-repeat;
    width: 35px;
    min-width: 35px;
    margin: 2px 0 0 20px;
    height: 100%;
    display: block;
  }
`

export const YolorektLogo = styled.a`
  ${designerCSS}
`
